import { useParams, Navigate } from "react-router-dom";

/**
 * /r/:code → forwards to /register?ref=CODE so the registration page
 * can show the inviter banner and capture the referral.
 */
export default function ReferralRedirect() {
  const { code } = useParams();
  const clean = (code || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 20);
  return <Navigate to={`/register?ref=${clean}`} replace />;
}
